import packTraceApi from '../../apis/packTrace.api'
import { ThunkResult } from '../../store'
import { replaceResult } from './PackTraces.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search } = getState().packTraces
    const params = { page, limit, search }
    packTraceApi.paginate(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}
